import React from 'react';
import PropTypes from 'prop-types';

const UiExpandCollapseLeftPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M7.205 8l4.419 4.42a.5.5 0 0 1 0 .707l-.884.883a.5.5 0 0 1-.707 0L4.376 8.354a.498.498 0 0 1 0-.708l5.657-5.656a.5.5 0 0 1 .707 0l.884.883a.5.5 0 0 1 0 .708L7.204 8z"
    />
  );
};

UiExpandCollapseLeftPath.propTypes = {
  fill: PropTypes.string,
};

export default UiExpandCollapseLeftPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-expand-collapse-left.jsx